import Paper from '@mui/material/Paper'

const Shadow = ({ children, ...props }) => {
	return <Paper {...props}>{children}</Paper>
}

Shadow.defaultProps = {}

Shadow.propTypes = {
	...Paper.propTypes,
}

export default Shadow
